import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component CheckboxDocumentsIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <CheckboxDocumentsIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <CheckboxDocumentsIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CheckboxDocumentsIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="CheckboxDocumentsIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M5 4h10.19L19 7.891V20H5V4zm11.03-2H5a2 2 0 00-2 2v16a2 2 0 002 2h14a2 2 0 002-2V7.075L16.03 2zm.667 9.82a1.105 1.105 0 00.02-1.499.96.96 0 00-1.414-.021l-4.446 4.58-2.16-2.225a.96.96 0 00-1.414.021c-.385.42-.376 1.09.02 1.499l2.16 2.225c.776.8 2.012.8 2.788 0l4.446-4.58z"
        clipRule="evenodd"
      />
    </svg>
  )
);
CheckboxDocumentsIcon.displayName = "CheckboxDocumentsIcon";
export default CheckboxDocumentsIcon;
